import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {BsArrowRight, BsArrowLeft} from "react-icons/bs"
import { ImageUrl } from '../../../../../Helpers/request';
import { LazyLoadImage } from "react-lazy-load-image-component";
const WhatPeopleSay = () => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        nextArrow: <span><BsArrowRight /></span>,
        prevArrow: <span><BsArrowLeft /></span>,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
    };
    return (
        <div className='testimo-jewelry2 parallax'>
            <Container>
                <Row>
                    <Col md={12} className='wht_hd '>
                        <h2 class="title24 white text-center m-0">What People Say</h2>					
                    </Col>

                    <Col>
                        <div className='testimo-slider2'>
                            <div class="testimonial-icon1">
                                <i class="fa fa-quote-left"></i>
                            </div>
                            <Slider {...settings}>
                                <div class="item-testimo2 text-center">
                                    <p class="desc ">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever <a href="#" target="_blank" class="review_read_more">Read more...</a></p>
                                    <ul class="reviews_icon">
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                    </ul>
                                    <h3 class="title18"><a href="#" class="txt-black">Lorem Ipsum</a></h3>

                                    <div class="reviewimg_p">
                                        <LazyLoadImage src={`${ImageUrl}theme/tokyo/ivouch-reviews.jpg`} alt="img" class="img-responsive" />
                                    </div>
                                </div>
                                <div class="item-testimo2 text-center">
                                    <p class="desc ">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever <a href="#" target="_blank" class="review_read_more">Read more...</a></p>
                                    <ul class="reviews_icon">
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                    </ul>
                                    <h3 class="title18"><a href="#" class="txt-black">Lorem Ipsum</a></h3>

                                    <div class="reviewimg_p">
                                        <LazyLoadImage src={`${ImageUrl}theme/tokyo/yelp-reviews.jpg`} alt="img" class="img-responsive" />
                                    </div>
                                </div>
                                <div class="item-testimo2 text-center">
                                    <p class="desc ">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever <a href="#" target="_blank" class="review_read_more">Read more...</a></p>
                                    <ul class="reviews_icon">
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                    </ul>
                                    <h3 class="title18"><a href="#" class="txt-black">Lorem Ipsum</a></h3>

                                    <div class="reviewimg_p">
                                        <LazyLoadImage src={`${ImageUrl}theme/tokyo/ivouch-reviews.jpg`} alt="img" class="img-responsive" />
                                    </div>
                                </div>
                                <div class="item-testimo2 text-center">
                                    <p class="desc ">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever <a href="#" target="_blank" class="review_read_more">Read more...</a></p>
                                    <ul class="reviews_icon">
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                    </ul>
                                    <h3 class="title18"><a href="#" class="txt-black">Lorem Ipsum</a></h3>

                                    <div class="reviewimg_p">
                                        <LazyLoadImage src={`${ImageUrl}theme/tokyo/ivouch-reviews.jpg`} alt="img" class="img-responsive" />
                                    </div>
                                </div>
                                <div class="item-testimo2 text-center">
                                    <p class="desc ">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever <a href="#" target="_blank" class="review_read_more">Read more...</a></p>
                                    <ul class="reviews_icon">
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                    </ul>
                                    <h3 class="title18"><a href="#" class="txt-black">Lorem Ipsum</a></h3>

                                    <div class="reviewimg_p">
                                        <LazyLoadImage src={`${ImageUrl}theme/tokyo/yelp-reviews.jpg`} alt="img" class="img-responsive" />
                                    </div>
                                </div>
                                <div class="item-testimo2 text-center">
                                    <p class="desc ">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever <a href="#" target="_blank" class="review_read_more">Read more...</a></p>
                                    <ul class="reviews_icon">
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                    </ul>
                                    <h3 class="title18"><a href="#" class="txt-black">Lorem Ipsum</a></h3>

                                    <div class="reviewimg_p">
                                        <LazyLoadImage src={`${ImageUrl}theme/tokyo/ivouch-reviews.jpg`} alt="img" class="img-responsive" />
                                    </div>
                                </div>
                            </Slider>
                        </div>
                        
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default WhatPeopleSay